import { gql } from '@apollo/client';

export const GET_ALL_BORROW_BOOKINGS = gql`
  query AllBorrowToolBookings($limit: Int!, $offset: Int!) {
    currentUser {
      id
      borrowToolBookings(limit: $limit, offset: $offset) {
        totalCount
        items {
          id
          fromDate
          toDate
          status
          totalPriceCents
          tool {
            id
            name
            primaryImageUrl
            description
          }
          bookingUser {
            id
            name
            avatarImageUrl
            reviewCount
            ratingAverage
          }
          owningUser {
            id
            name
            avatarImageUrl
            reviewCount
            ratingAverage
          }
          messageThread {
            id
            subject
          }
        }
      }
    }
  }
`;
